<template>
  <v-card
    outlined
    class="px-6 pt-6 pb-3"
  >
    <div class="d-flex flex-row justify-space-between align-center pb-3 ">
      <label class="subtitle-1 d-block grey--text">{{ page_title }}</label>
    </div>

    <v-text-field
      outlined
      label="Title"
      :hint="hint_msg"
      v-model="titleListener"
    />

    <v-textarea
      outlined
      name="input-7-4"
      label="Description"
      :hint="hint_msg"
      v-model="descriptionListener"
    />

    <image-file-input-viewer
      :clearable="clearable"
      v-model="imageListener"
    />

  </v-card>
</template>
<script>
import ImageFileInputViewer from './ImageFileInputViewer'

export default {
  props: {
    title: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    image: {
      type: [String, Object, File],
      default () {
        return null
      }
    },
    page_title: {
      type: String,
      default: 'Social Sharing Meta Tags'
    },
    hint_msg: {
      type: String,
      default: 'Keep it short and sweet. Facebook recommends 2–4 sentences, but that often truncates.'
    }
  },
  components: {
    ImageFileInputViewer
  },
  data () {
    return {
      initialImage: this.image
    }
  },
  computed: {
    titleListener: {
      get () {
        return this.title
      },
      set (val) {
        this.$emit('update:title', val)
      }
    },
    descriptionListener: {
      get () {
        return this.description
      },
      set (val) {
        this.$emit('update:description', val)
      }
    },
    imageListener: {
      get () {
        return this.image
      },
      set (val) {
        if (val === null || val === undefined) {
          /**
           * Revert the value of the image to initial image
           */
          if (this.initialImage !== null) {

            val = this.initialImage
          }
        }
        this.$emit('update:image', val)
      }
    },
    clearable () {
      if (this.imageListener instanceof File) {
        return true
      }

      return false
    }
  }
}
</script>
